import Vue from 'vue';

if(document.getElementById('booking-form-page')) {

    Vue.component('booking-form', require('@/components/Booking/Form').default);

    const feed = new Vue({
        name: 'Booking Form',
        el: '#booking-form-page',
    });

}
